import { render } from "./PrivateVaultImage.vue?vue&type=template&id=9c3e6c9c"
import script from "./PrivateVaultImage.vue?vue&type=script&lang=js"
export * from "./PrivateVaultImage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__